import { Component, OnInit, inject } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';

import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IframeDialogComponent, LoadingSkeletonComponent } from '@components';
import { environment } from '@environments/environment';
import { GknFundamentalCardLink } from '@services';
import { BreakpointService } from 'src/app/@shared/services/breakpoint/breakpoint.service';
import { HomeFundamentalsCardComponent } from '../home-fundamentals-card/home-fundamentals-card.component';
import { HomeFundamentalsCardType } from '../home-fundamentals-card/home-fundamentals-card.enum';
import { HomeFundamentalsStatusService } from './home-fundamentals-status.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-home-fundamentals-status',
    imports: [CommonModule, HomeFundamentalsCardComponent, LoadingSkeletonComponent, MatIconModule, MatTooltipModule],
    providers: [HomeFundamentalsStatusService],
    templateUrl: './home-fundamentals-status.component.html',
    styleUrls: ['./home-fundamentals-status.component.scss'],
})
export class HomeFundamentalsStatusComponent implements OnInit {
    private breakpointService = inject(BreakpointService);
    private dialog = inject(MatDialog);
    private fundamentalsStatusService = inject(HomeFundamentalsStatusService);

    cardType = HomeFundamentalsCardType.STATUS;
    incidents$: Observable<GknFundamentalCardLink[]>;

    ngOnInit(): void {
        this.incidents$ = this.fundamentalsStatusService.incidents$;
    }

    openAllStatuses(): void {
        firstValueFrom(this.breakpointService.mobile$)
            .then((mobile) => {
                this.dialog.open(IframeDialogComponent, {
                    width: mobile ? '' : '80%',
                    maxWidth: BreakpointService.contentMaxWidth,
                    height: mobile ? '90%' : '80%',
                    autoFocus: false,
                    data: {
                        title: HomeFundamentalsCardType.STATUS,
                        src: environment.feed.gcStatus.url,
                        dataAnalytics: 'fundamentals-status',
                    },
                });
            })
            .catch((e) => {
                throw e;
            });
    }

    openIncident(link: GknFundamentalCardLink) {
        firstValueFrom(this.breakpointService.mobile$)
            .then((mobile) => {
                this.dialog.open(IframeDialogComponent, {
                    width: mobile ? '' : '80%',
                    maxWidth: BreakpointService.contentMaxWidth,
                    height: mobile ? '90%' : '80%',
                    autoFocus: false,
                    data: {
                        title: HomeFundamentalsCardType.STATUS,
                        subtitle: link?.label,
                        src: link?.url,
                        dataAnalytics: 'fundamentals-status',
                    },
                });
            })
            .catch((e) => {
                throw e;
            });
    }

    openAllUpdates(): void {
        firstValueFrom(this.breakpointService.mobile$)
            .then((mobile) => {
                this.dialog.open(IframeDialogComponent, {
                    width: mobile ? '' : '80%',
                    maxWidth: BreakpointService.contentMaxWidth,
                    height: mobile ? '90%' : '80%',
                    autoFocus: false,
                    data: {
                        title: HomeFundamentalsCardType.STATUS,
                        src: `${environment.feed.gcStatus.url}/#past-incidents`,
                        dataAnalytics: 'fundamentals-status',
                    },
                });
            })
            .catch((e) => {
                throw e;
            });
    }
    /**
     * Track by Item
     * @param _index - item index
     * @param item - GknFundamentalCardLink
     * @returns number or string unique identifier
     */
    trackByItem(_index: number, item: GknFundamentalCardLink): NonNullable<number | string> {
        if (item.url) {
            return item.url;
        } else {
            return _index;
        }
    }
}
